import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressBarService } from './progress-bar.service';

/**
 * A global progress bar component that displays at the top of the viewport.
 *
 * Uses TailwindCSS for styling and animations.
 * Subscribes to ProgressBarService to show/hide based on application state.
 *
 * @example
 * ```html
 * <app-progress-bar></app-progress-bar>
 * ```
 */
@Component({
  selector: 'app-progress-bar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './progress-bar.component.html'
})
export class ProgressBarComponent {
  private progressBarService = inject(ProgressBarService);

  /**
   * Observable stream indicating whether the progress bar should be active/visible.
   */
  isActive$ = this.progressBarService.isActive();
}
